import * as Sentry from "@sentry/react-native";

import type { AppUserSession } from "@/schemas/auth/session";
import { fetchDiagnostics } from "@/screens/Settings/Troubleshooting/Services/diagnosticService";

export async function sendDiagnosticsToSentry(
  session: AppUserSession | null,
): Promise<void> {
  const diagnosticRun = await fetchDiagnostics(session);
  Sentry.captureException(new Error("Diagnostics Report"), {
    extra: diagnosticRun,
  });
}
